"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteContact = void 0;

var ImmutableAPI = _interopRequireWildcard(require("crm_data/api/ImmutableAPI"));

var base_url = 'contacts/v1/gdpr/internal/gdpr-delete';

var deleteContact = function deleteContact(vids, email) {
  return ImmutableAPI.post(base_url, {
    vids: vids,
    email: email
  });
};

exports.deleteContact = deleteContact;